import styled from 'styled-components';

export const BonusDepositPanelWrapperStyled = styled.div`
    background-image: linear-gradient(270deg, #EBC962 0%, #B67F3C 100%);
    padding: 1px;
    border-radius: 4px;
    position: relative;
    width: 100%;
`;

export const BonusDepositPanelIconContainerStyled = styled.div`
    position: absolute;
    display: flex;
    left: 14px;
    top: 0;
    padding: 0 2px;
    background-color: var(--color-surface-secondary);
    transform: translateY(-50%);
`;

export const BonusDepositPanelContainerStyled = styled.div`
    background-color: var(--color-surface-secondary);
    border-radius: 4px;
    padding: 24px 8px 8px;
    font-size: 16px;
`;

export const BonusDepositPanelAccordionWrapperStyled = styled.div`
    &.accordion {
        border: none;
        &:hover {
            .accordion-button {
                color: var(--color-white);
            }
            border: none;
        }
    }
    .accordion-button {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 2px !important;
        color: var(--text-color-secondary);
        :after {
            display: none;
        }
        :not(.collapsed) {
            box-shadow: none;
            background-color: var(--color-surface);
            color: var(--text-color-secondary);
        }
    }
    .accordion-body {
        padding: 0;
        max-height: 232px;
        overflow-y: scroll;
        font-size: 14px;
        font-weight: 400;
    }
    .accordion-body::-webkit-scrollbar {
        width: 16px;
    }

    .accordion-body::-webkit-scrollbar-thumb {
        background-color: var(--color-secondary-active);
        border-radius: 20px;
        border: 6px solid var(--color-surface-secondary);
    }
    
    .accordion-collapse.show {
        border-radius: 2px !important;
        background-color: var(--color-surface);

        .accordion-body::-webkit-scrollbar-thumb {
            border-color: var(--color-surface);
        }
    }
    
    .collapsing {
        transition: none;
    }
`;

export const BonusDepositPanelTotalAmountStyled = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px;
    background: var(--color-main);
    color: var(--text-color-secondary);
    border-radius: 4px;
`;

export const BonusDepositPanelMoneyStyled = styled.div`
    color: var(--color-white);
    font-weight: 600;
`
